import React from 'react';

const Pioniers = () => {
  const [open, setOpen] = React.useState(false);
  return ( //ref={this.myRef}
    <div data-section-name="pioniers" className="secondSlide" id="pioniers">
      <div className={["section snap project program baltan pioniers", open ? "open" : null].join(" ")}>
        <div className="projecttext">
          <div className="projectmarquee">
            <div className="menu__item">
              <a href="pioniers" className="menu__item-link" 
              onMouseEnter={() => { setOpen(!open);}} onMouseLeave={() => { setOpen(!open);}}>
              Tegenlicht<br />Pioneers</a>
              <div className="marquee">
                <div className="marquee__inner" aria-hidden="true">
                  <span>Tegenlicht<br />Pioneers</span>
                  <span>Tegenlicht<br />Pioneers</span>
                  <span>Tegenlicht<br />Pioneers</span>
                  <span>Tegenlicht<br />Pioneers</span>
                </div>
              </div>
            </div>
          </div>
          <div className="description side">
            <h4>Platform for pioneers</h4>
            <h5>user experience design &amp; visual design</h5>
          </div>
        </div>
        <div className="image-right small">
        </div>
      </div>
    </div>
  );
};

export default Pioniers;